import React from 'react'
import styled from 'styled-components'

import { gray, primaryHovered } from 'styles/colors'

const Wrapper = styled.div`
  cursor: pointer;
`

const Svg = styled.svg`
  fill: ${props => (props.hover ? primaryHovered : gray)};
`

class X extends React.Component {
  state = {
    hover: false,
  }

  render() {
    return (
      <Wrapper
        {...this.props}
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}>
        <Svg
          width="12px"
          height="12px"
          viewBox="0 0 12 12"
          hover={this.state.hover}>
          <g stroke="none" strokeWidth="1" fillRule="evenodd">
            <polygon points="11.82 1.36 7.18 6 11.82 10.64 10.64 11.82 6 7.18 1.36 11.82 0.18 10.64 4.82 6 0.18 1.36 1.36 0.18 6 4.82 10.64 0.18" />
          </g>
        </Svg>
      </Wrapper>
    )
  }
}

export default X



// WEBPACK FOOTER //
// ./src/components/icons/X.js